import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getPlanoCopiaList } from './selectdbAtions';
import LabelAndSelect from '../form/labelAndSelect';

class SelectPlanoSelect extends Component {
  componentDidMount() {
    if (this.props['data-controlador-id']) {
      this.props.getPlanoCopiaList(this.props['data-controlador-id']);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props['data-controlador-id'] !== prevProps['data-controlador-id']) {
      if (this.props['data-controlador-id']) {
        this.props.getPlanoCopiaList(this.props['data-controlador-id']);
      }
    }
  }

  render() {
    const { list } = this.props;

    const modoAtual = parseInt(this.props['data-modo-operacao-id'], 10);
    let planosFiltrados = [];

    // Se um modo de operação foi passado, filtra a lista de planos.
    if (!isNaN(modoAtual) && list) {
      const pares = {
        0: [0, 3], // Isolado/Normal e Sincronizado/Normal
        1: [1, 4], // Isolado/Atuado e Sincronizado/Atuado
        2: [2, 5], // Isolado/Atuado com SL e Sincronizado/Atuado com SL
        3: [0, 3],
        4: [1, 4],
        5: [2, 5],
        6: [6, 7], // Adaptativo Local e Adaptativo Sincronizado
        7: [6, 7],
      };

      const modosPermitidos = pares[modoAtual];

      if (modosPermitidos) {
        planosFiltrados = list.filter(plano => modosPermitidos.includes(plano.modo_operacao_id));
      }
    } else {
      // Caso contrário (ou se a lista não carregou), usa a lista completa ou um array vazio.
      planosFiltrados = list || [];
    }

    return (
      <LabelAndSelect label={this.props.label} name={this.props.name} cols={this.props.cols} id={this.props.id}>
        <option value="0">Selecione</option>
        {planosFiltrados.map((item, i) => (
          <option key={i} value={item.id} id={item.controlador_id}>
            {item.descricao}
          </option>
        ))}
      </LabelAndSelect>
    );
  }
}

const mapStateToProps = state => ({ list: state.planoCad.planoCopiaList });
const mapDispatchToProps = dispatch => bindActionCreators({ getPlanoCopiaList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectPlanoSelect);
